import React, { useEffect, useState } from 'react'
// import { ValidatorComponent } from 'react-form-validator-core'

const ComboField = (props) => {
  const [isValid, setIsValid] = useState(false)
  const [searchFilter, setSearchFilter] = useState('')
  const [filteredData, setFilteredData] = useState(props.options);
  const [filteredDataJSX, setFilteredDataJSX] = useState();
  const [showListBox, setShowListBox] = useState(false);

  const {
    errorMessages,
    validators,
    requiredError,
    validatorListener,
    withRequiredValidator,
    icon,
    id,
    handleInputChange,
    inputValue,
    ...rest
  } = props

  const errorStyles = {
    color: '#f25961',
    fontSize: '80%',
    fontWeight: 600,
  }

  // Handle Search Filter
  useEffect(() => {
    var result = props.options?.filter((item) => {
      if (typeof item == 'object') {
        for(var key in item) {
          if(item.hasOwnProperty(key) && item[key] && item[key].toString().toLowerCase().indexOf(searchFilter.toLowerCase()) !== -1) {
            return true;
          }
        }
      } else if (typeof item == 'string') {
        if (item.toLowerCase().indexOf(searchFilter.toLowerCase()) !== -1) { return true; }
      }

      return false;
    });

    setShowListBox(true);
    setFilteredData(result);
  }, [searchFilter, props.options, setFilteredData])

  // Handle Input Change event
  const handleOnChange = (ev) => {
    const { inputType, indexVal, name } = props;

    if (inputType == 'indexed') {
      handleInputChange(ev.target?.value, indexVal, name)
    } else {
      handleInputChange({ ...inputValue, [ev?.target?.name]: ev?.target?.value })
    }

    setSearchFilter(ev.target.value)
  }

  // Handle Select On Click event
  const handleListSelect = (val) => {
    const { capslock, inputType, indexVal, name } = props;

    if (inputType == 'indexed') {
      handleInputChange(capslock ? val.value.toUpperCase() : val.value, indexVal, name)
    } else {
      handleInputChange({ ...inputValue, conviction: capslock ? val.value.toUpperCase() : val.value })
    }

    setSearchFilter('')
    setShowListBox(false)
  }

  const getErrorMessage = () => {
    setIsValid(true)
  }

  const errorText = () =>
    isValid ? null : (
      <div style={errorStyles}>{getErrorMessage()}</div>
    )

  useEffect(() => {
    const populateList = () => {
      const { capslock } = props;

      return filteredData?.map((x, index) => 
        (<button key={index}
          className='btn btn-outline-primary text-sm px-1 mb-1'
          style={{}}
          onClick={() => handleListSelect(x)}
        >
          {capslock ? x.value.toUpperCase() : x.value}
        </button>))
    }

    setFilteredDataJSX(populateList())
  }, [searchFilter])

  if (!rest.className) rest.className = 'form-control'
  if (!isValid) rest.className += ' input_error'

  const charsLeft = rest.maxLength ? (
    <span className='text-muted textarea-chars-remaining'>
      {Number(rest.maxLength) - rest.value.length} characters left
    </span>
  ) : null

  return (
    <React.Fragment>
      <div className='input-group relative'>
        <textarea {...rest} onChange={ev => handleOnChange(ev)}/>
        {(showListBox && searchFilter.length >= 2 && filteredDataJSX.length > 0) &&
            <div className='z-10 fixed w-screen h-screen inset-0' onClick={() => setShowListBox(false)}/>
        }
        {(showListBox && searchFilter.length >= 2 && filteredDataJSX.length > 0) &&
            <div
              id={id}
              className='flex flex-column py-1 px-1 z-20 overflow-y-scroll'
              style={{maxHeight: '220px', maxWidth: '200px', height: '220px', width: '200px',
                position: 'absolute', border: '1px solid lightgrey', backgroundColor: 'white',
                right: '-110%'
              }}
            >
              {filteredDataJSX}
            </div>
        }
        {icon === null ? null : (
          <div className='input-group-append'>
            <span className='input-group-text'>
              <i className={'fas fa-' + (icon || 'font')}></i>
            </span>
          </div>
        )}
      </div>
      {errorText()}
      {charsLeft}
    </React.Fragment>
  )
}

export default ComboField
